// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"45afb34f","787":"7b0f414c"}[chunkId] + ".chunk.js";
};